import { Star } from "lucide-react";

const reviews = [
  {
    name: "Priya Sharma",
    role: "Class 10 Student",
    review: "EduLabs has transformed how I study. The classroom features make it so easy to collaborate with my teacher!",
    rating: 5,
  },
  {
    name: "Rajesh Kumar",
    role: "Teacher",
    review: "As a teacher, I love how I can create custom exams and track my students' progress all in one place.",
    rating: 5,
  },
  {
    name: "Ananya Patel",
    role: "Class 12 Student",
    review: "The exam features are incredibly helpful. I can practice at my own pace and see where I need to improve.",
    rating: 5,
  },
  {
    name: "Vikram Singh",
    role: "Teacher",
    review: "Creating and managing classrooms has never been easier. My students are more engaged than ever!",
    rating: 5,
  },
  {
    name: "Meera Reddy",
    role: "Class 9 Student",
    review: "I joined my teacher's classroom in seconds and now I get all my assignments in one place.",
    rating: 5,
  },
  {
    name: "Arjun Mehta",
    role: "Teacher",
    review: "The platform is intuitive and powerful. I can focus on teaching while EduLabs handles the rest.",
    rating: 5,
  },
];

const ReviewsWall = () => {
  return (
    <section className="py-24 overflow-hidden bg-foreground text-background">
      <div className="container mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl lg:text-6xl font-black leading-tight tracking-tight">
            Loved by students
            <br />
            & teachers.
          </h2>
        </div>

        <div className="relative">
          <div className="flex animate-scroll-left gap-6 py-4">
            {[...reviews, ...reviews].map((review, index) => (
              <div
                key={index}
                className="flex-shrink-0 w-80 bg-background/10 backdrop-blur-sm border border-background/10 rounded-3xl p-7"
              >
                <div className="flex items-center gap-1 mb-4">
                  {[...Array(review.rating)].map((_, i) => (
                    <Star key={i} className="h-4 w-4 fill-primary text-primary" />
                  ))}
                </div>
                <p className="text-background/80 mb-5 line-clamp-3 text-sm leading-relaxed">
                  "{review.review}"
                </p>
                <div className="flex items-center gap-3">
                  <div className="h-10 w-10 rounded-full bg-primary flex items-center justify-center">
                    <span className="text-primary-foreground font-bold text-sm">{review.name[0]}</span>
                  </div>
                  <div>
                    <p className="font-bold text-sm text-background">{review.name}</p>
                    <p className="text-xs text-background/50">{review.role}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default ReviewsWall;
